<template>
  <div>
    <a href="javascript:" id="acc-link" class="acc-link" @click="openAccess()">
      <span>{{ $t("footer.accessibility-link") }}</span>
    </a>
    <md-dialog
      role="dialog"
      :aria-modal="openAccessibility"
      :md-active.sync="openAccessibility"
      :no-close-on-esc="false"
      :md-click-outside-to-close="false"
      id="accessibility"
      @keydown.esc="showDialog = false"
      @keydown.tab="
        utils.handleTabNavigation($event, null, null, '#accessibility', null)
      "
      @md-opened="
        noScroll();
        !isMobile ? utils.modalOpened('#accessibility') : '';
      "
      @md-closed="
        !isMobile ? utils.removeModalHandler() : '';
        scroll();
      "
    >
      <md-dialog-title>
        <h1 class="title md-title">{{ $t("footer.title") }}</h1>
        <div class="md-layout-item">
          <md-button
            @click="closeAccess()"
            class="md-icon-button close-button"
            :aria-label="$t('footer.close-accessibility')"
          >
            <md-tooltip
              v-bind:style="isMobile ? 'display: none;' : ''"
              class="tooltip"
              style="z-index: 30"
              >{{ $t("footer.close-accessibility") }}
            </md-tooltip>
            <md-icon
              class="md-size-1x"
              style="color: black !important"
              aria-hidden="true"
              role="presentation"
              >close</md-icon
            >
          </md-button>
        </div>
      </md-dialog-title>

      <md-dialog-content class="content-space">
        <!--<div class="title space">
          Valutazione essenziale di accessibilità
        </div>-->
        <h2 class="title2">Premessa</h2>
        <p class="space">
          Il CINECA ha intrapreso un percorso di adeguamento di tutti i propri
          prodotti e servizi alla normativa AgID sull'accessibilità, a partire
          da quelli esposti al pubblico e agli utenti finali. Questo processo di
          adeguamento sta coinvolgendo sia i servizi più recenti e basati già su
          tecnologie moderne, già in corso di analisi e correzione, sia i
          prodotti e servizi legacy, che richiederanno un completo refactoring.
        </p>
        <h2 class="title2">Redazione della dichiarazione di accessibilità</h2>
        <p class="space">
          La presente <strong>dichiarazione di accessibilità</strong> per il
          servizio “uVote” è frutto di una
          <i>valutazione di accessibilità</i> basata sul “Modello di
          dichiarazione di accessibilità sito web e applicazione mobile”
          (Allegato 1 alle linee guida sull'accessibilità degli strumenti
          informatici) di AgID e riferita alle Linee Guida sull'Accessibilità
          degli strumenti informatici
          (https://www.agid.gov.it/it/design-servizi/accessibilita/linee-guida-accessibilita-strumenti-informatici)
          emanate da AgID in attuazione della Direttiva UE 2016/2102. Si tratta
          di una verifica tecnica di conformità alle linee guida di
          accessibilità WCAG 2.1 (https://www.w3.org/Translations/WCAG21-it/) di
          livello "AA". La prima dichiarazione è stata redatta il 1 ottobre
          2020.<br />La dichiarazione è aggiornata al 30 agosto 2023 in cui è
          stata effettuata una valutazione con metodologia di verifica a
          campione secondo i criteri illustrati nelle Linee Guida di
          accessibilità AGID al Capitolo 5
          (https://docs.italia.it/AgID/documenti-in-consultazione/lg-accessibilita-docs/it/stabile/metodologia-di-monitoraggio.html).
        </p>
        <h2 class="title2">Descrizione del servizio erogato</h2>
        <p class="space">
          Il percorso di adeguamento alla normativa AgID intrapreso dal CINECA
          coinvolge anche il servizio “uVote online”, versione moderna di uVote,
          il sistema di voto elettronico costruito dal CINECA, che aggiunge una
          funzionalità di voto online alla precedente versione. L'interfaccia di
          uVote è stata progettata all'insegna della user experience allo scopo
          di migliorarne l'usabilità e l'esperienza per tutti gli utenti. uVote
          è inoltre fruibile su varie piattaforme, sui browser più diffusi e,
          grazie all'approccio responsive, si adatta dinamicamente alle
          caratteristiche del dispositivo utilizzato (smartphone, tablet, pc
          desktop), consentendo una navigazione ottimizzata su dispositivi con
          dimensione/risoluzione differenti in modo del tutto trasparente
          all'utente.
        </p>
        <h2 class="title2">Stato di conformità e raccomandazioni</h2>
        <p class="space">
          Dalla presente valutazione emerge una parziale conformità del prodotto
          ai requisiti di accessibilità. Queste non conformità verranno gestite
          secondo una roadmap di interventi migliorativi e saranno spunti di
          miglioramento per i prossimi rilasci.
        </p>
        <p class="space">
          Oltre ad un monitoraggio prolungato nel tempo della conformità del
          prodotto ai requisiti tecnici di accessibilità e ad un approccio di
          miglioramento costante dell'usabilità, è stata condotta una
          valutazione soggettiva del livello di qualità del servizio, da parte
          di persone con disabilità visive, mirata a verificare l’effettiva
          possibilità di utilizzare lo strumento di votazione anche da parte di
          ipovedenti e non vedenti. In questa fase di verifica, gli utenti
          ipovedenti hanno utilizzato prevalentemente lo zoom di sistema ed in
          alcuni casi si sono avvalsi dell’inversione dei colori, mentre gli
          utenti non vedenti hanno utilizzato alcuni dei più diffusi screen
          reader. La piattaforma di votazione è risultata essere fruibile e
          accessibile sia da parte di persone ipovedenti, sia non vedenti e
          tutti gli utenti sono riusciti a completare con successo le votazioni
          previste durante l’esecuzione dei test.
        </p>
        <h2 class="title2">Contenuti non accessibili o migliorabili</h2>
        <p class="space">
          <md-table>
            <md-table-row>
              <md-table-head>Criterio</md-table-head
              ><md-table-head>Esito</md-table-head>
            </md-table-row>
            <md-table-row>
              <md-table-cell>
                2.1.1 Tastiera (Level A) <br />
                9.2.1.1 Tastiera
              </md-table-cell>
              <md-table-cell
                >Alcuni elementi sottostanti le dialog sono segnalati come non essere raggiungibili da
                tastiera fino a chiusura della dialog stessa. Migliorabile pertanto la gestione degli attributi.
              </md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell
                >2.2.1 Regolazione tempi di esecuzione (Level A) <br />
                9.2.2.1 Regolazione tempi di esecuzione
              </md-table-cell>
              <md-table-cell
                >Per ragioni di sicurezza non è possibile disattivare o
                estendere il limite temporale.</md-table-cell
              >
            </md-table-row>
            <md-table-row>
              <md-table-cell
                >4.1.2 Nome, ruolo, valore (Level A) <br />
                9.4.1.2 Nome, ruolo, valore
              </md-table-cell>
              <md-table-cell
                >Migliorabile la gestione dell'attributo ARIA richiesto per tab e switch.
                L'attuale gestione dell'attributo è limitata a specifiche situazioni
                legate al framework applicativo.</md-table-cell
              >
            </md-table-row>
          </md-table>
        </p>
        <h2 class="title2">Roadmap degli interventi correttivi</h2>
        <p class="space">
          Gli interventi correttivi volti al miglioramento dei suddetti
          contenuti non accessibili sono programmati per il terzo trimestre
          2024.
        </p>
        <h2 class="title2">Feedback e informazioni di contatto</h2>
        <p class="space bottom">
          Per segnalare eventuali difficoltà di accessibilità al servizio
          contattare il supporto all’indirizzo supporto-tecnico-evote@cineca.it.
        </p>
      </md-dialog-content>
      <md-dialog-actions style="justify-content:center">
        <md-button
          @click="closeAccess()"
          :aria-label="$t('footer.close-accessibility')"
          class="chiudi-button"
          tabindex="0"
        >
          <md-tooltip
            v-bind:style="isMobile ? 'display: none;' : ''"
            class="tooltip"
            style="z-index: 30"
            >{{ $t("footer.close-accessibility") }}
          </md-tooltip>
          {{ $t("footer.close-button") }}</md-button
        >
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import Utils from "../utils/Utils.js";

export default {
  mounted() {
    this.isMobile = isMobile;
    this.utils = new Utils();
  },
  data: function() {
    return {
      isMobile: false,
      openAccessibility: false,
      utils: null,
      cookieContainer: null
    };
  },
  props: [],
  methods: {
    openAccess() {
      this.openAccessibility = true;
    },
    closeAccess() {
      this.openAccessibility = false;
    },
    noScroll() {
      document.documentElement.style.overflow = "hidden";
      document.getElementById("app").setAttribute("aria-hidden", "true");
      document
        .getElementById("app")
        .querySelectorAll("input,button,a")
        .forEach(x => (x.tabIndex = "-1"));
      document.getElementById("logout").tabIndex = "-1";
      this.lastFocus = document.activeElement;
    },
    scroll() {
      document.documentElement.style.overflow = "auto";
      document.getElementById("app").setAttribute("aria-hidden", "false");
      document
        .getElementById("app")
        .querySelectorAll("input,button,a")
        .forEach(x => x.removeAttribute("tabindex"));
      document.getElementById("logout").removeAttribute("tabindex");

      this.lastFocus.focus();
    }
  }
};
</script>
<style scoped>
.title {
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.005em;
  line-height: 26px;
  color: rgb(0, 0, 0);
  text-align: center;
}
.title2 {
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.005em;
  line-height: 24px;
  color: rgb(0, 0, 0);
  margin: 15px 0px 15px 0px;
  padding: 0px 0px 10px 0px;
}
.content-space {
  padding: 0px 45px 0px 45px !important;
}
.space {
  margin: 10px;
  padding: 0px 15px 10px 15px;
}
.space.bottom {
  margin-bottom: 40px !important;
}
.md-table-head,
.md-table-cell {
  font-size: 14px;
}
.md-ripple {
  margin-right: 20px;
}
.close-button {
  position: absolute;
  top: 5px !important;
  right: -2px !important;
}
.chiudi-button {
  background-color: #fff !important;
  border: 1px solid var(--pcolor);
  color: var(--pcolor) !important;
}

.md-dialog.all {
  width: 35% !important;
  height: auto !important;
  max-width: 90% !important;
  max-height: 90% !important;
}

a.acc-link:link {
  color: #000000;
  text-decoration: underline;
}
a.acc-link:visited {
  color: #000000;
  text-decoration: none;
}
a.acc-link:hover {
  color: #000000;
  text-decoration: underline;
}
a.acc-link:active {
  color: #000000;
  text-decoration: none;
}

.md-button {
  border-radius: var(--brb);
}

@media screen and (max-width: 667px) {
  .content-space {
    padding: 0px 20px 0px 20px !important;
  }

  .space {
    margin: 0;
    padding: 0;
  }
}
</style>
